/**
 * THE SPORT'S OWN PICTURE, beside "Choose your star" on the player screen.
 * One slot per sport: upload it, or take it away again in one tap. A sport with
 * no picture keeps the star icon it has today, and nothing is shared between
 * sports — a hockey picture can never turn up on a football night.
 */
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import api from '../../../lib/api';
import { ImageField } from './ImageField';

export const GoalSportImageBlock = ({ orgId }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const s = (k) => t(`goalGame.sportImage.${k}`);

    const load = useCallback(async () => {
        if (!orgId) return;
        try {
            const res = await api.get('/goal-game/admin/sport-images',
                { params: { organization_id: orgId } });
            setData(res.data);
        } catch (_e) { setData(null); }
    }, [orgId]);

    useEffect(() => { load(); }, [load]);

    const save = async (league, imageUrl) => {
        try {
            const res = await api.put('/goal-game/admin/sport-images', {
                organization_id: orgId, league, image_url: imageUrl || '' });
            setData((prev) => ({ ...(prev || {}), ...res.data }));
            toast.success(imageUrl ? s('saved') : s('removed'));
        } catch (_e) { toast.error(s('failed')); }
    };

    if (!data) return null;

    return (
        <div className="space-y-3" data-testid="gg-sport-images">
            <p className="text-xs text-slate-500">{s('hint')}</p>
            <div className="grid sm:grid-cols-2 gap-3">
                {(data.leagues || []).map((l) => (
                    <ImageField key={l.id} label={l.label} hint={s('slotHint')}
                                value={(data.images || {})[l.id] || ''}
                                endpoint="sport-image" responseKey="image_url"
                                orgId={orgId} extraFields={{ league: l.id }}
                                testid={`gg-sport-image-${l.id}`}
                                onChange={(url) => save(l.id, url)} />
                ))}
            </div>
        </div>
    );
};

export default GoalSportImageBlock;
